import React, { useState, useEffect, useContext, useRef } from "react";
import { UserContext } from "../../contexts/UserContext";
import InputCheckBoxCustomComponent from "./InputCheckBoxCustomComponent";
import { Overlay, Tooltip } from "react-bootstrap";
import { isMobileOrTablet } from "../Views/MobileClassRenderer";
import EventUserProfilePicture from "./EventUserProfilePicture";
import EventUserAvailabilityIndicator from "./EventUserAvailabilityIndicator";

export default function EventUserItem({
  id,
  item,
  handleChange,
  isSelected,
  selectedValuesCount,
  MAX_INVITES,
  isInviting,
  hasProfilePicture,
}) {
  const [isItemSelected, setIsItemSelected] = useState(isSelected);
  const { me } = useContext(UserContext);
  const [tooltipMessage, setTooltipMessage] = useState("");
  const [maxShow, setMaxShow] = useState(false);
  const target = useRef(null);

  function isAvailable() {
    const availability = getAvailability();
    return availability == 1;
  }

  function getAvailability() {
    if (item.id === me.id) {
      return me.availability;
    }
    return item.availability;
  }

  function handleOnClick() {
    if (isAvailable() && !isInviting) {
      const isAlreadySelected = isItemSelected ? 1 : 0;

      if (
        selectedValuesCount - isAlreadySelected === 8 &&
        isItemSelected !== true
      ) {
        openTooltip(`You can invite ${MAX_INVITES} participants`);
      }

      if (selectedValuesCount - isAlreadySelected >= 11) {
        setIsItemSelected(false);
        openTooltip(`You can only invite ${MAX_INVITES} participants`);
      } else {
        setIsItemSelected((prevState) => !prevState);
      }
    }
  }

  function openTooltip(message) {
    setMaxShow(true);
    setTooltipMessage(message);
    setTimeout(() => {
      setMaxShow(false);
    }, 1500);
  }

  function isValidUser() {
    return item && item?.user && item?.user?.firstName;
  }

  // function toolTipDisplayMessage() {

  //   const isAlreadySelected = isItemSelected ? 1 : 0
  //   if (selectedValuesCount - isAlreadySelected === 8 && isItemSelected === true) {
  //     return `You can invite ${MAX_INVITES} participants`
  //   } else if (selectedValuesCount - isAlreadySelected >= 11) {
  //     return `You can only invite ${MAX_INVITES} participants`
  //   }
  // }

  useEffect(() => {
    handleChange(id, isItemSelected ? item : false);
  }, [isItemSelected]);

  return (
    <>
      {isValidUser() && (
        <div
          className={`visitor-item row g-0 py-2 ${isAvailable() ? "" : "is-offline"}`}
          ref={target}
          onClick={handleOnClick}
        >
          <div className=" col-md-10 col d-flex align-items-center">
            {hasProfilePicture ? (
              <EventUserProfilePicture
                eventUser={item}
                availability={getAvailability()}
              />
            ) : (
              <EventUserAvailabilityIndicator
                availability={getAvailability()}
              />
            )}
            {item.user?.firstName && item.user?.lastName && (
              <>
                {!isMobileOrTablet() ? (
                  <div 
                    className="mb-0 ms-3"
                    style={{
                      width: "80%",
                    }}
                  >
                    {item.user?.firstName} {item.user?.lastName}
                    {item.title && item.company && (
                      <span style={{ color: "gray", paddingLeft: "10px" }}>
                        {item.title} at {item.company}
                      </span>
                    )}
                  </div>
                ) : (
                  <p className="mb-0 ms-3">
                    {item.user?.firstName} {item.user?.lastName}
                    {item.title && item.company && (
                      <span>
                        {item.title} at {item.company}
                      </span>
                    )}
                  </p>
                )}
              </>
            )}
          </div>
          <div className="col-md-2 col d-flex align-items-center justify-content-end">
              <div
                className="circle-checkbox float-end pb-0 mb-0"
                style={{
                  width: "24px",
                  height: "24px",
                  border: `2px solid ${
                    isSelected
                      ? "var(--vv-primary)"
                      : `${
                          !isMobileOrTablet()
                            ? "var(--vv-gray2)"
                            : "var(--vv-gray5)"
                        }`
                  }`,
                  background: isSelected
                    ? `
                    radial-gradient(circle, var(--vv-primary) 44%, var(--vv-dark-transparent-0) 48%)
                  `
                    : "",
                }}
              >
                {/* <InputCheckBoxCustomComponent isSelected={isSelected} id={id} /> */}
                <span
                  className={`${
                    isSelected ? "d-block" : "d-none"
                  } rounded-circle ms-1 mt-1`}
                  style={{
                    width: "8px",
                    height: "8px",
                    backgroundColor: "var(--vv-primary)",
                  }}
                ></span>
              </div>
          </div>
        </div>
      )}
      <Overlay
        target={target.current}
        show={maxShow}
        placement={isMobileOrTablet() ? "top" : "right"}
      >
        {(props) => (
          <Tooltip id={`max-participants-${id}`} {...props}>
            {tooltipMessage}
          </Tooltip>
        )}
      </Overlay>
    </>
  );
}
